module.exports = [
    '$scope',
function (
    $scope
) {

}];



// WEBPACK FOOTER //
// ./app/common/auth/forbidden.controller.js